import { convertPrice } from "./convertPrice";

let formatPrice = (value) => {
    let val = value.toString()
        val = val.replace(/\s/g, '');
        val = val.replace(',', '.');
        val = val.replace('AED', '');
        val = parseFloat(val);

    let input = parseFloat(val).toFixed(2);

    return convertPrice(input);

}

export default formatPrice;